// src/components/Category/CategoryItem.js
import React from 'react';
import { Link } from 'react-router-dom';

const CategoryItem = ({ category }) => {
    if (!category) return null;

    // 🔧 اگر فیلد product_count وجود نداشت (API قدیمی)، همه زیردسته‌ها را نمایش بده
    const hasProductCount = category.product_count !== undefined;
    
    // فیلتر زیردسته‌ها: فقط آنهایی که product_count > 0 دارند (اگر product_count موجود باشد)
    let childrenWithProducts = category.children || [];
    if (hasProductCount) {
        childrenWithProducts = childrenWithProducts.filter(child => child.product_count > 0);
    }
    
    // خود دسته دارای محصول است؟
    const hasSelfProducts = hasProductCount ? (category.product_count > 0) : true; // اگر product_count نبود، فرض می‌کنیم دارد
    
    // اگر خود دسته محصول ندارد و هیچ زیردسته‌ای (با محصول) ندارد، نمایش نده
    if (!hasSelfProducts && childrenWithProducts.length === 0) {
        return null;
    }

    const parentLink = `/products/list/${category.slug}`;
    const iconFallback = category.name.charAt(0);
    const iconColor = category.color_class && category.color_class.startsWith('#') 
        ? category.color_class 
        : (category.color_class ? `#${category.color_class}` : '#e5e7eb');

    return (
        <div className="category-item-wrapper rtl w-full bg-white border border-gray-200 rounded-lg shadow-sm transition-shadow duration-200">
            <Link 
                to={parentLink} 
                className="flex items-center p-4 group"
                title={`بیشتر ${category.name}`}
            >
                <div 
                    className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-transform duration-200 group-hover:scale-105" 
                    style={{ backgroundColor: iconColor }} 
                >
                    <span className="text-2xl font-bold text-white">
                        {iconFallback}
                    </span>
                </div>
                <div className="mr-4 flex-grow">
                    <h3 className="text-[12px] font-bold text-gray-800 transition-colors group-hover:text-indigo-700">
                        {category.name}
                    </h3>
                </div>
            </Link>

            {/* نمایش زیردسته‌ها (فقط در صورت وجود) */}
            {childrenWithProducts.length > 0 && (
                <div className="subcategory-list bg-gray-50 p-4 border-t border-gray-100 rounded-b-lg flex flex-wrap gap-2">
                    {childrenWithProducts.map(child => (
                        <Link
                            key={child.slug}
                            to={`/products/list/${category.slug}/${child.slug}`}
                            className="text-xs font-medium bg-white text-gray-700 border border-gray-300 rounded-full px-3 py-1 hover:bg-gray-100 hover:border-gray-400 transition-colors"
                        >
                            {child.name}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CategoryItem;